exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*::-moz-selection {\n  background: var(--text-highlight-color);\n}\n*::selection {\n  background: var(--text-highlight-color);\n}\n*::-moz-selection {\n  background: var(--text-highlight-color);\n}\n*::selection {\n  background: var(--text-highlight-color);\n}\n.mp-report-banners.has-banners {\n  margin-bottom: 20px;\n}\n.mp-report-banners mp-banner:not(:first-child) {\n  margin-top: 20px;\n}\n.mp-report-banners mp-banner.banner-hidden {\n  display: none;\n}\n", ""]);

// exports
